import React from 'react';

export const useDebouncedState = <T>(defaultValue: T, delay: number) => {
  const [debouncedValue, setDebouncedValue] = React.useState<T>(defaultValue);
  const [value, setValue] = React.useState<T>(defaultValue);

  React.useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  React.useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return [value, debouncedValue, setValue] as const;
};
